import {Alert, Link} from '@mui/material';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

const GlobalBanner: React.FC = () => {
  const {i18n} = useTranslation();

  return (
    <Alert severity="info" icon={false} sx={{borderRadius: 0, justifyContent: 'center'}}>
      <Trans
        i18nKey="Уважаемые партнёры, портал закрыт. Новая система доступна по адресу importx5.ru"
        i18n={i18n}
        tOptions={{keySeparator: false}}
        components={[
          <Link href="https://importx5.ru" target="_blank" rel="noopener noreferrer" underline="always">
            importx5.ru
          </Link>,
        ]}
      />
    </Alert>
  );
};

export default GlobalBanner;
